import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import FerrariStatement from "@/components/FerrariStatement";
import Manifesto from "@/components/Manifesto";
import CoverageCalculator from "@/components/CoverageCalculator";
import Scheduling from "@/components/Scheduling";
import Voices from "@/components/Voices";
import Journal from "@/components/Journal";
import About from "@/components/About";
import Footer from "@/components/Footer";

function Home() {
  return (
    <>
      <Header />
      <main data-testid="home-main">
        <Hero />
        <EditorialMarquee />
        <FerrariStatement />
        <About />
        <Manifesto />
        <CoverageCalculator />
        <Scheduling />
        <Voices />
        <Journal />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <SmoothScroll>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0A1128",
              color: "#F7F5F0",
              border: "1px solid rgba(247,245,240,0.15)",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
              letterSpacing: "0.02em",
            },
          }}
        />
      </div>
    </SmoothScroll>
  );
}
